var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiIconsTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2H20C21.1 2 22 2.9 22 4V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2ZM4 4V20H20V4H4ZM15.91 8.57C15.83 8.53 15.75 8.48 15.67 8.43C15.45 8.28 15.24 8.11 15.06 7.91C14.61 7.39 14.44 6.87 14.38 6.5C14.33 6.19 14.35 6 14.35 6H12.29V13.97C12.29 14.08 12.29 14.18 12.29 14.29C12.29 14.3 12.29 14.32 12.29 14.33C12.29 14.33 12.29 14.34 12.29 14.35C12.25 14.94 11.92 15.46 11.41 15.74C11.15 15.89 10.86 15.97 10.56 15.97C9.6 15.97 8.82 15.19 8.82 14.22C8.82 13.25 9.6 12.47 10.56 12.47C10.74 12.47 10.92 12.5 11.1 12.55V10.45C10.04 10.31 8.97 10.63 8.15 11.31C7.79 11.62 7.5 11.99 7.27 12.4C7.18 12.55 6.85 13.15 6.81 14.13C6.78 14.69 6.95 15.26 7.03 15.5C7.08 15.65 7.27 16.12 7.59 16.53C7.84 16.85 8.15 17.14 8.48 17.37C9.48 18.05 10.58 18 10.58 18C10.77 18 11.41 18 12.14 17.65C12.95 17.27 13.41 16.7 13.41 16.7C13.7 16.36 13.94 15.97 14.1 15.55C14.29 15.06 14.35 14.47 14.35 14.24V10.01L14.71 10.25C14.71 10.25 15.19 10.56 15.94 10.76C16.48 10.9 17.2 10.93 17.2 10.93V8.88C16.95 8.91 16.43 8.83 15.9 8.56L15.91 8.57Z",
    fill: "#003865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiIconsTiktok);
export default __webpack_public_path__ + "static/media/bi-icons-tiktok.427f1452596ad4018f44f269afc075e3.svg";
export { ForwardRef as ReactComponent };